import { render } from "./Waiver.vue?vue&type=template&id=01edd3d8"
import script from "./Waiver.vue?vue&type=script&lang=js"
export * from "./Waiver.vue?vue&type=script&lang=js"

import "./Waiver.vue?vue&type=style&index=0&id=01edd3d8&lang=less"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__